import type { ButtonHTMLAttributes, ReactNode } from "react";

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "color" | "size"> {
	className?: string;
	types?: ButtonTypes[];
	color?: ButtonColor;
	size?: "small" | "medium" | "large";
	fullWidth?: boolean;
	loading?: boolean;
	children?: ReactNode;
}

export enum ButtonTypes {
	Primary,
	Danger,
	Green,
	Circle,
	Text,
	Warning,
	Outline,
	Icon,
}

export class ButtonColor {
	static DarkBlue: "darkBlue" = "darkBlue";
	static Red: "red" = "red";
	static Green: "green" = "green";
	static DarkGreen: "darkGreen" = "darkGreen";
	static LightBlue: "lightBlue" = "lightBlue";
	static DarkYellow: "darkYellow" = "darkYellow";
}

export class ButtonSize {
	static small: "small" = "small";
	static medium: "medium" = "medium";
	static large: "large" = "large";
}
